import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20abstract%20waves%20with%20warm%20cream%20and%20sand%20beige%20gradient%2C%20gentle%20flowing%20organic%20curves%2C%20clean%20modern%20aesthetic%2C%20light%20airy%20atmosphere%2C%20diffused%20natural%20lighting%2C%20elegant%20texture%2C%20editorial%20lifestyle%20background%2C%20no%20sharp%20elements&width=1800&height=1200&seq=hero-bg-v5-unique&orientation=landscape"
          alt="Mulebuy Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 pt-24 pb-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Left: Text Content */}
            <div className="w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm border border-background-50/30 rounded-full mb-6">
                <span className="w-2 h-2 bg-accent-400 rounded-full animate-pulse"></span>
                <span className="text-xs font-medium text-background-50">Updated for 2026</span>
              </div>

              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
                Ultimate Mulebuy Spreadsheet Guide 2026
              </h1>

              <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
                Discover how the mulebuy spreadsheet system works, compare platforms, and learn how to shop smarter, faster, and cheaper in 2026.
              </p>

              {/* Trust Signals */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mb-8">
                <span className="flex items-center gap-1.5 text-sm text-background-50/75">
                  <i className="ri-checkbox-circle-line text-accent-400"></i>
                  Updated 2026
                </span>
                <span className="flex items-center gap-1.5 text-sm text-background-50/75">
                  <i className="ri-checkbox-circle-line text-accent-400"></i>
                  Beginner Friendly
                </span>
                <span className="flex items-center gap-1.5 text-sm text-background-50/75">
                  <i className="ri-checkbox-circle-line text-accent-400"></i>
                  Transparent System
                </span>
                <span className="flex items-center gap-1.5 text-sm text-background-50/75">
                  <i className="ri-checkbox-circle-line text-accent-400"></i>
                  Step-by-Step Tutorials
                </span>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-bold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
                >
                  Mulebuy Spreadsheet
                  <i className="ri-arrow-right-up-line"></i>
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-bold rounded-full hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
                >
                  Buy It Now
                  <i className="ri-shopping-bag-line"></i>
                </a>
              </div>
            </div>

            {/* Right: Image Grid */}
            <div className="hidden lg:block">
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                  <div className="w-full h-64 rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20minimal%20decor%20and%20laptop%2C%20warm%20cream%20wall%20background%2C%20soft%20diffused%20side%20lighting%2C%20editorial%20photography%2C%20professional%20workspace%2C%20neutral%20beige%20and%20taupe%20palette&width=800&height=500&seq=hero-grid-v3-1&orientation=landscape"
                      alt="Mulebuy spreadsheet workspace"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="w-full h-48 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20white%20athletic%20shoe%20on%20minimal%20cream%20surface%2C%20soft%20natural%20studio%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20style&width=500&height=500&seq=hero-grid-v3-2&orientation=squarish"
                    alt="Shoes category"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-full h-48 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Soft%20knit%20sweater%20folded%20on%20minimal%20cream%20surface%2C%20warm%20natural%20studio%20lighting%2C%20clean%20product%20photography%2C%20neutral%20taupe%20tones%2C%20editorial%20fashion%20style&width=500&height=500&seq=hero-grid-v3-3&orientation=squarish"
                    alt="Hoodies category"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}